import { APP_URLS } from 'constants/urls';
import { BreadCrumbsOptions } from './types';
import getDashboardHomeItem from './dashboardHomeItem';

export default function getFormTemplatesBreadcrumbMap({
  pathname,
  t,
  entity,
}: BreadCrumbsOptions) {
  const dashboardHomeItem = getDashboardHomeItem({ t });
  const formTemplatesItem = {
    label: t('form-templates'),
    path: APP_URLS.dashboard.formTemplates.index.getPathWithQuery(),
  };

  return [
    {
      condition:
        APP_URLS.dashboard.formTemplates.index.isTheSameUrlAs(pathname),
      data: [
        dashboardHomeItem,
        {
          label: t('form-templates'),
        },
      ],
    },
    {
      condition:
        APP_URLS.dashboard.formTemplates.archived.isTheSameUrlAs(pathname),
      data: [
        dashboardHomeItem,
        {
          label: t('form-templates'),
        },
      ],
    },
    {
      condition:
        APP_URLS.dashboard.formTemplates.categories.isTheSameUrlAs(pathname),
      data: [
        dashboardHomeItem,
        formTemplatesItem,
        {
          label: t('categories'),
        },
      ],
    },
    {
      condition: APP_URLS.dashboard.formTemplates.add.isTheSameUrlAs(pathname),
      data: [
        dashboardHomeItem,
        formTemplatesItem,
        {
          label: t('create-new-form'),
        },
      ],
    },
    {
      condition: APP_URLS.dashboard.formTemplates.edit.isTheSameUrlAs(
        pathname,
        {
          pathParts: {
            id: `${entity?.id}`,
          },
        },
      ),
      data: [
        dashboardHomeItem,
        formTemplatesItem,
        {
          label: t('view-details'),
          path: APP_URLS.dashboard.formTemplates.viewVersion.getDynamicPath({
            pathParts: {
              id: `${entity?.id}`,
              versionId: `${entity?.versionId}`,
            },
          }),
        },
        {
          label: t('edit-form-details'),
        },
      ],
    },
    {
      condition: APP_URLS.dashboard.formTemplates.editVersion.isTheSameUrlAs(
        pathname,
        {
          pathParts: {
            id: `${entity?.id}`,
            versionId: `${entity?.versionId}`,
          },
        },
      ),
      data: [
        dashboardHomeItem,
        formTemplatesItem,
        {
          label: entity?.name,
        },
      ],
    },
    {
      condition: APP_URLS.dashboard.formTemplates.viewVersion.isTheSameUrlAs(
        pathname,
        {
          pathParts: {
            id: `${entity?.id}`,
            versionId: `${entity?.versionId}`,
          },
        },
      ),
      data: [
        dashboardHomeItem,
        formTemplatesItem,
        {
          label: entity?.name,
        },
      ],
    },
    {
      condition:
        APP_URLS.dashboard.formTemplates.viewLinkedTasks.isTheSameUrlAs(
          pathname,
          {
            pathParts: {
              id: `${entity?.id}`,
              versionId: `${entity?.versionId}`,
            },
          },
        ),
      data: [
        dashboardHomeItem,
        formTemplatesItem,
        {
          label: t('view-details'),
          path: APP_URLS.dashboard.formTemplates.viewVersion.getDynamicPath({
            pathParts: {
              id: `${entity?.id}`,
              versionId: `${entity?.versionId}`,
            },
          }),
        },
        {
          label: entity?.name,
        },
      ],
    },
    {
      condition:
        APP_URLS.dashboard.formTemplates.viewLinkedDocuments.isTheSameUrlAs(
          pathname,
          {
            pathParts: {
              id: `${entity?.id}`,
              versionId: `${entity?.versionId}`,
            },
          },
        ),
      data: [
        dashboardHomeItem,
        formTemplatesItem,
        {
          label: t('view-details'),
          path: APP_URLS.dashboard.formTemplates.viewVersion.getDynamicPath({
            pathParts: {
              id: `${entity?.id}`,
              versionId: `${entity?.versionId}`,
            },
          }),
        },
        {
          label: entity?.name,
        },
      ],
    },
    {
      condition: APP_URLS.dashboard.formTemplates.duplicate.isTheSameUrlAs(
        pathname,
        {
          pathParts: {
            id: `${entity?.id}`,
            versionId: `${entity?.versionId}`,
          },
        },
      ),
      data: [
        dashboardHomeItem,
        formTemplatesItem,
        {
          label: t('duplicate-form-template'),
          path: APP_URLS.dashboard.formTemplates.viewVersion.getDynamicPath({
            pathParts: {
              id: `${entity?.id}`,
              versionId: `${entity?.versionId}`,
            },
          }),
        },
        {
          label: entity?.name,
        },
      ],
    },
  ];
}
